import MyMap from "./map";
export default MyMap;